import React from "react";
import type { LineItemRepresentation } from "src/api/interfaces/line_item";
import DataTable from "src/components/DataTable";
import documentItemsErrorDataTableDefinition from "./document-items-error-data-table-definition";

const DocumentItemsErrorTable = ({
  content,
}: {
  content: LineItemRepresentation;
}) => {
  return (
    <DataTable
      id={`product-items-error-${content.index}`}
      tableDefinition={documentItemsErrorDataTableDefinition}
      contents={content.validationErrors}
    />
  );
};

export default DocumentItemsErrorTable;
